/* eslint-disable max-len */
import { makeStyles } from '@mui/styles';
import Container from 'components/Container/Container';
import BgSvg from 'components/Img/pitems-min.jpg';
// @ts-expect-error ts-migrate(2307) FIXME: Cannot find module 'components/Img/manin-peace.svg... Remove this comment to see the full error message
import ManInPace from 'components/Img/manin-peace.svg';
import config from 'config';
import { memo } from 'react';
import { Helmet } from 'react-helmet-async';

import { Grid, Paper, Typography } from '@mui/material';
import { useTranslation } from '../../hooks/useTranslation';

const useStyles = makeStyles(
  (theme) => ({
    '@keyframes peaceicon': {
      '0%': {
        animationTimingFunction: 'ease-in, ease-in-out',
        transform: 'matrix(1,0,0,1,3,8)',
      },
      '50%': {
        animationTimingFunction: 'ease-in, ease-in-out',
        transform: 'matrix(1,0,0,1,3,17)',
      },
      '100%': {
        animationTimingFunction: 'ease-in, ease-in-out',
        transform: 'matrix(1,0,0,1,3,8)',
      },
    },
    bg: {
      display: 'flex',
      color: '#fff',
      backgroundImage: `url(${BgSvg})`,
      minHeight: 800,
      width: 'calc(100% + 2px)',
      backgroundSize: 'cover',
      backgroundPosition: 'center center',
    },
    container100: {
      height: '100%',
    },
    containerFeatures: {
      paddingTop: 50,
      zIndex: 99,
      position: 'relative',
      top: -25,
      // backgroundColor: '#e1eaf8',
      // paddingBottom: 72,
      '&:after': {
        height: 72,
        width: '100%',
        position: 'absolute',
        zIndex: -1,
        bottom: 0,
        content: '" "',
        display: 'block',
        // eslint-disable-next-line max-len
        backgroundImage:
          // eslint-disable-next-line quotes
          "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='none' viewBox='0 0 100 100'><polygon fill='#fff' points='0,40 0,100 100,100 0,0' /></svg>\")",
        backgroundRepeat: 'no-repeat',
      },
    },
    paperFeatures: {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'spacing' does not exist on type 'Default... Remove this comment to see the full error message
      padding: theme.spacing(10),
    },
    typoWithIcon: {
      display: 'inline-flex',
    },
    iconsWithText: {
      fontSize: 28,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'spacing' does not exist on type 'Default... Remove this comment to see the full error message
      marginRight: theme.spacing(3),
    },
    containerSecond: {
      position: 'relative',
      bottom: -120,
    },
    containerContentSecond: {},
    peaceicon: {
      '& g > g > g > g:nth-child(2)': {
        animationName: '$peaceicon',
        animationDuration: '3s',
        animationIterationCount: 'infinite',
      },
    },
    paper: {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'spacing' does not exist on type 'Default... Remove this comment to see the full error message
      padding: theme.spacing(5),
      boxShadow: 'none',
    },
    paperNorrmal: {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'spacing' does not exist on type 'Default... Remove this comment to see the full error message
      padding: theme.spacing(5),
    },
    iconBox: {
      fontSize: 70,
      marginBottom: 40,
    },
    containerOver: {
      position: 'relative',
      top: -220,
    },
    manInPeace: {
      paddingTop: 40,
      paddingBottom: 50,
      backgroundImage: `url(${ManInPace})`,
      backgroundRepeat: 'no-repeat',
      // backgroundSize: 'contain',
      backgroundPosition: 'right top',
    },
  }),
  { name: 'BringerProhibited' }
);

const Home = memo(
  () => {
    const classes = useStyles();
    const title = 'Bringer Parcel Xpress';
    // eslint-disable-next-line
    const description =
      'Ship anywhere in the world with a click. Our online tools let you ship with confidence without downloading software';

    const { t } = useTranslation();

    const ldjson = {
      '@context': 'http://schema.org',
      '@type': 'WebSite',
      url: config.domain,
      name: config.app.title,
      alternateName: 'Bringer',
      image: `${config.domain}/bpx-logo-white.png`,
      sameAs: [
        'https://www.facebook.com/Bringer',
        'https://instagram.com/Bringer',
        'https://www.linkedin.com/company/Bringer/',
        'https://twitter.com/@Bringer',
      ],
    };

    const ldjsonOrg = {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: config.app.title,
      legalName: 'Bringer CORP',
      email: `mailto:contact@${config.host}`,
      url: config.domain,
      logo: `${config.domain}/bpx-logo-white.png`,
      sameAs: [
        'https://www.facebook.com/Bringer',
        'https://instagram.com/Bringer',
        'https://www.linkedin.com/company/Bringer/',
        'https://twitter.com/@Bringer',
      ],
    };

    return (
      <>
        <Helmet>
          <title>{title}</title>
          <link rel="canonical" href={`${config.domain}/`} />
          <meta name="description" content={description} />
          <meta property="og:title" content={title} />
          <meta property="twitter:title" content={title} />
          <meta name="og:description" content={description} />
          <meta name="twitter:description" content={description} />
          <meta property="og:type" content="website" />
          <meta name="robots" content="index, follow" />
          <script type="application/ld+json">{JSON.stringify(ldjson)}</script>
          <script type="application/ld+json">{JSON.stringify(ldjsonOrg)}</script>
        </Helmet>
        <div className={classes.bg}>
          <Container>
            <Grid container alignItems="center" className={classes.container100}>
              <Grid item xs={12} sm={6}>
                <Typography variant="h2" component="h1" color="inherit" gutterBottom>
                  {t('public.prohibited')}
                </Typography>
              </Grid>
            </Grid>
          </Container>
        </div>
        <div className={classes.containerFeatures}>
          <Container className={classes.containerOver}>
            <Grid container className={classes.containerSecond}>
              <Grid item xs={12}>
                <Grid container spacing={2} justifyContent="space-between">
                  <Grid item xs={12} sm={12} className={classes.containerContentSecond}>
                    <Paper className={classes.paper} elevation={1}>
                      <Typography>
                        <span>
                          <strong>
                            <span>
                              <span>
                                <span>{t('public.prohibited.1')}</span>
                              </span>
                            </span>
                          </strong>
                        </span>
                      </Typography>
                      <ol start="1">
                        <li>
                          <span>
                            <span>
                              <span>{t('public.prohibited.2')}</span>
                            </span>
                          </span>
                        </li>
                        <li>
                          <span>
                            <span>
                              <span>{t('public.prohibited.3')}</span>
                            </span>
                          </span>
                        </li>
                        <li>
                          <span>
                            <span>
                              <span>{t('public.prohibited.4')}</span>
                            </span>
                          </span>
                        </li>
                        <li>
                          <span>
                            <span>
                              <span>{t('public.prohibited.5')}</span>
                            </span>
                          </span>
                        </li>
                        <li>
                          <span>
                            <span>
                              <span>{t('public.prohibited.6')}</span>
                            </span>
                          </span>
                        </li>
                        <li>
                          <span>
                            <span>
                              <span>{t('public.prohibited.7')}</span>
                            </span>
                          </span>
                        </li>
                      </ol>
                      <Typography>
                        <span>
                          <span>
                            <span>o&nbsp;&nbsp; </span>
                          </span>
                          <span>
                            <span>
                              <span>{t('public.prohibited.8')}</span>
                            </span>
                          </span>
                        </span>
                      </Typography>
                      <Typography>
                        <span>
                          <span>
                            <span>o&nbsp;&nbsp; </span>
                          </span>
                          <span>
                            <span>
                              <span>{t('public.prohibited.9')}</span>
                            </span>
                          </span>
                        </span>
                      </Typography>
                      <Typography>
                        <span>
                          <span>
                            <span>o&nbsp;&nbsp; </span>
                          </span>
                          <span>
                            <span>
                              <span>{t('public.prohibited.10')}</span>
                            </span>
                          </span>
                        </span>
                      </Typography>
                      <Typography>
                        <span>
                          <span>
                            <span>o&nbsp;&nbsp; </span>
                          </span>
                          <span>
                            <span>
                              <span>{t('public.prohibited.11')}</span>
                            </span>
                          </span>
                        </span>
                      </Typography>
                      <ol start="7">
                        <li>
                          <span>
                            <span>
                              <span>{t('public.prohibited.12')}</span>
                            </span>
                          </span>
                        </li>
                        <li>
                          <span>
                            <span>
                              <span>{t('public.prohibited.13')}</span>
                            </span>
                          </span>
                        </li>
                        <li>
                          <span>
                            <span>
                              <span>{t('public.prohibited.14')}</span>
                            </span>
                          </span>
                        </li>
                        <li>
                          <span>
                            <span>
                              <span>{t('public.prohibited.15')}</span>
                            </span>
                          </span>
                        </li>
                        <li>
                          <span>
                            <span>
                              <span>{t('public.prohibited.16')}</span>
                            </span>
                          </span>
                        </li>
                        <li>
                          <span>
                            <span>
                              <span>{t('public.prohibited.17')}</span>
                            </span>
                          </span>
                        </li>
                        <li>
                          <span>
                            <span>
                              <span>{t('public.prohibited.18')}</span>
                            </span>
                          </span>
                        </li>
                        <li>
                          <span>
                            <span>
                              <span>{t('public.prohibited.19')}</span>
                            </span>
                          </span>
                        </li>
                        <li>
                          <span>
                            <span>
                              <span>{t('public.prohibited.20')}</span>
                            </span>
                          </span>
                        </li>
                        <li>
                          <span>
                            <span>
                              <span>{t('public.prohibited.21')}</span>
                            </span>
                          </span>
                        </li>
                        <li>
                          <span>
                            <span>
                              <span>{t('public.prohibited.22')}</span>
                            </span>
                          </span>
                        </li>
                        <li>
                          <span>
                            <span>
                              <span>{t('public.prohibited.23')}</span>
                            </span>
                          </span>
                        </li>
                        <li>
                          <span>
                            <span>
                              <span>{t('public.prohibited.24')}</span>
                            </span>
                          </span>
                        </li>
                        <li>
                          <span>
                            <span>
                              <span>{t('public.prohibited.25')}</span>
                            </span>
                          </span>
                        </li>
                        <li>
                          <span>
                            <span>
                              <span>{t('public.prohibited.26')}</span>
                            </span>
                          </span>
                        </li>
                        <li>
                          <span>
                            <span>
                              <span>{t('public.prohibited.27')}</span>
                            </span>
                          </span>
                        </li>
                        <li>
                          <span>
                            <span>
                              <span>{t('public.prohibited.28')}</span>
                            </span>
                          </span>
                        </li>
                        <li>
                          <span>
                            <span>
                              <span>{t('public.prohibited.29')}</span>
                            </span>
                          </span>
                        </li>
                      </ol>
                      <Typography>
                        <span>
                          <span>
                            <span>
                              <span>{t('public.prohibited.30')}</span>
                            </span>
                          </span>
                        </span>
                        <br />
                        <span>
                          <span>
                            <span>
                              <span>{t('public.prohibited.31')}</span>
                            </span>
                            <br />
                            <span>
                              <span>{t('public.prohibited.32')}</span>
                            </span>
                          </span>
                        </span>
                      </Typography>
                    </Paper>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Container>
        </div>
      </>
    );
  },
  () => true
);

export default Home;
